import { render, staticRenderFns } from "./VerificationDetails.vue?vue&type=template&id=827fe6a4&scoped=true&"
import script from "./VerificationDetails.vue?vue&type=script&lang=js&"
export * from "./VerificationDetails.vue?vue&type=script&lang=js&"
import style0 from "./VerificationDetails.vue?vue&type=style&index=0&id=827fe6a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827fe6a4",
  null
  
)

export default component.exports